/**
 * @file 面包屑组件，通常作为 Page 的一部分
 */

import { isArray } from '@seiue/util'
import { Breadcrumb } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'

import { RouteCrumb } from './hooks'

export * from './hooks'

type BreadcrumbsProps = {
  className?: string
  breadcrumbs: RouteCrumb[]
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  className,
  breadcrumbs,
}) => {
  const showBreadcrumbs = breadcrumbs.length > 1

  return (
    <>
      {showBreadcrumbs && (
        <Breadcrumb className={className}>
          {breadcrumbs.map(route => {
            const menuGroup = route.menu?.group()
            const group = isArray(menuGroup) ? menuGroup[1] : null

            const key = route.path || route.getTitle?.()
            return (
              <React.Fragment key={key}>
                {group && <Breadcrumb.Item>{group}</Breadcrumb.Item>}
                <Breadcrumb.Item>
                  {route.realPath ? (
                    <Link
                      to={{ pathname: route.realPath, search: route.search }}
                    >
                      {route.getTitle?.()}
                    </Link>
                  ) : (
                    route.getTitle?.()
                  )}
                </Breadcrumb.Item>
              </React.Fragment>
            )
          })}
        </Breadcrumb>
      )}
    </>
  )
}
